module.exports = __webpack_public_path__ + "media/images/design/common/images/h3_menu-630d8e8822148ed5865420ab9f9ebdd5.png";